export default function ProductCarriers() {
  return {
    productCategory: 'Term',
    productCarrierData: [
      {
        carrierName: "Corebridge",
        displayOrder: 1,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/corebridge_logo.svg",
      },
      {
        carrierName: "Equitable",
        displayOrder: 2,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/equitable_logo.svg",
      },
      {
        carrierName: "John Hancock",
        displayOrder: 3,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/John_hancock_logo.svg",
      },
      {
        carrierName: "Legal & General",
        displayOrder: 4,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/lga_logo.svg",
      },
      {
        carrierName: "Lincoln",
        displayOrder: 5,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/lincoln_financial_logo.svg",
      },
      {
        carrierName: "Mass Mutual",
        displayOrder: 6,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/massmutual_logo.svg",
      },
      {
        carrierName: "Mutual of Omaha",
        displayOrder: 7,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/mutual_of_omaha_logo.svg",
      },
      {
        carrierName: "Nationwide",
        displayOrder: 8,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/nationwide_logo.svg",
      },
      {
        carrierName: "Pacific Life",
        displayOrder: 9,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/pacific_life_logo.svg",
      },
      {
        carrierName: "Protective",
        displayOrder: 10,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/protective_logo.svg",
      },
      {
        carrierName: "Prudential",
        displayOrder: 11,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/prudential_logo.svg",
      },
      {
        carrierName: "SBLI",
        displayOrder: 12,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/sbli_logo.svg",
      },
      {
        carrierName: "Securian",
        displayOrder: 13,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/securian_logo.svg",
      },
      {
        carrierName: "Symetra",
        displayOrder: 14,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/symetra_logo.svg",
      },
      {
        carrierName: "Transamerica",
        displayOrder: 15,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/svg/transamerica_logo.svg",
      },
    ],
  };
}
